import React, { useEffect, useState } from 'react';
import SummaryApi from '../common';
import noservice from '../assest/noservice.png';

const AllServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 8;

  useEffect(() => {
    fetch(SummaryApi.getAllServices.url)
      .then((res) => res.json())
      .then((data) => {
        setServices(data.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching services:", err);
        setLoading(false);
      });
  }, []);

  if (loading)
    return <p className="text-center mt-10 text-gray-500">Loading services...</p>;

  if (services.length === 0)
    return (
      <div className="flex flex-col items-center justify-center mt-10 text-gray-500">
        <img src={noservice} alt="No Services" className="w-48 h-48 mb-4" />
        <p>No services available.</p>
      </div>
    );

  // Pagination logic
  const totalPages = Math.ceil(services.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = services.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: "smooth" }); // optional: auto-scroll to top on page change
    }
  };

  return (
    <>
      {/* Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6">
        {currentItems.map((service) => {
          const fileName = service.service_img?.split("/").pop();
          const imageUrl = fileName
            ? `${SummaryApi.serviceImg.url}/${fileName}`
            : noservice;

          return (
            <div
              key={service.service_id}
              className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <img
                src={imageUrl}
                alt={service.service_name}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold mb-2">{service.service_name}</h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                  {service.service_desc}
                </p>
                <p className="text-indigo-600 font-bold text-lg">
                  ₹{parseFloat(service.service_price).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                  })}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center gap-2 py-4">
        <button
          className="px-3 py-1 border rounded-lg hover:bg-gray-200"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index + 1}
            onClick={() => handlePageChange(index + 1)}
            className={`px-3 py-1 border rounded-lg ${
              currentPage === index + 1
                ? "bg-indigo-600 text-white"
                : "hover:bg-gray-200"
            }`}
          >
            {index + 1}
          </button>
        ))}

        <button
          className="px-3 py-1 border rounded-lg hover:bg-gray-200"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default AllServices;
